// src/constants/locations.js
export const BAY_AREA_CITIES = [
  'Oakland',
  'Alameda',
  'Emeryville',
  'Berkeley',
  // More cities will be added as the platform expands to new regions
];